import { io } from "socket.io-client";

let socket = null;

export const connectSocket = (token) => {
  socket = io(process.env.REACT_APP_SERVER_URL, {
    transports: ["websocket"],
    auth: { token },
  });

  socket.on("connect", () => {
    console.log("✅ Socket conectado:", socket.id);
  });

  socket.on("disconnect", () => {
    console.warn("🔌 Socket desconectado");
  });

  return socket;
};

export const getSocket = () => socket;
